<template>
  <div class="home pay">
    <van-nav-bar left-text="上社保 找亿企评" @click-left="onClickLeft">
      <a :href="'tel:' + phone" slot="right" class="hd-title"><i class="tel-icon"></i>{{phone}}</a>
    </van-nav-bar>

    <section class="social-methods">
        <div class="canbaoInfo">
          <div class="social-pay">
            <h4><span class="detail-label">订单编号：</span>{{orderId}}</h4>
            <h4><span class="detail-label">参保确认：</span>{{cityName}}</h4>
            <h4><span class="detail-label">参保内容：</span>{{insContValue}}</h4>
            <h4><span class="detail-label">联系人：</span>{{contactTel}}</h4>
            <ul class="payDetailList clearfix" v-for="(item, index) in socialList" :key="index">
              <li>{{item.name}}</li>
              <li class="w-240">{{item.userId}}</li>
              <li>{{item.monthNum}}个月</li>
              <li class="w-88">{{item.contentType==1?'新参保':'续缴'}}</li>
              <li class="w-88">{{item.cityConfigName}}</li>
            </ul>
            <h4>费用合计：</h4>
            <h5><span class="detail-label">代收费用：</span><span>¥{{charge}}</span></h5>
            <h5><span class="detail-label">服务费：</span><span>¥{{serviceCharge}}</span></h5>
            <h4><span class="detail-label">费用合计：</span><span class="totalNum">¥{{totalPrice}}</span></h4>
          </div>
        </div>
    </section>

    <section class="pay-methods">
      <h4>支付方式</h4>
      <div class="pay-box">
        <div class="pay-methods-list v-flex">
          <div class="pay-alipay" :class="{active:show == 0}" @click="tabNav(1)">
            <img :src="curImg == show ? require('../../assets/img/alipay-w.png'):require('../../assets/img/alipay-b.png')" alt="">
            支付宝支付
          </div>
          <div class="pay-wx" :class="{active:show == 1}" @click="tabNav(0)">
            <img :src="curImg == show ? require('../../assets/img/wx-g.png'):require('../../assets/img/wx-w.png')" alt="">
            微信支付
          </div>
        </div>
        <div class="pay-methods-content">
          <div class="ercode" id="qrcode"></div><!-- 创建一个div，并设置id为qrcode -->
          <h5>请用{{show==0?'支付宝':'微信'}}扫描二维码进行支付</h5>
          <van-button size="small" type="info" @click="toAlipay" v-if="show==0">打开支付宝付款</van-button>
          <van-button size="small" type="info" @click="toWeiXin" v-if="show==1">打开微信付款</van-button>
        </div>

        <h4 class="backHome" @click="onClickLeft">返回首页</h4>
        <h5 class="btm-tips"><span style="color: red;">*</span>适用浏览器：手机默认浏览器、Chrome、Safari、百度、QQ、360、搜狗. 不支持UC及其他浏览器。</h5>
      </div>
    </section>

  </div>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from 'vuex'
  import Qs from 'qs'
  import QRCode from 'qrcodejs2'
  import Title from '../../components/Title/Title'
  export default {
    name: 'Home',
    components: {
      Title
    },
    data () {
      return {
        phone: '400-110-9919',
        orderId: "", //订单号
        cityName:"",//最终选中的地区的名字
        cityCode:"",//最终选中的地区的id
        insContValue: "",  //参保内容显示的内容
        insContId: "",
        contactTel: "",
        curSerIndex: "",
        socialList: [],
        sureCbInfo: true,
        charge: "", //代收费用
        serviceCharge: "", //服务费
        totalPrice: "", //合计费用
        show: 0,
        curImg: 0,
        alipayUrl: "",
        wxUrl: "",
        timer: "",
        wexinUrl: ""
      }
    },
    methods: {
      onClickLeft() {
        this.$router.push({name: 'Home'});
      },
      tabNav(val) {
        if(val == 0){
          this.qrcode(this.wxUrl);
          this.show = 1;
        } else {
          this.qrcode(this.alipayUrl);
          this.show = 0;
        }
      },
      qrcode(url) {
        document.getElementById("qrcode").innerHTML = ""; //即生成二维码之前先将存放二维码的标签清空
        this.$nextTick(() => {
          let qrcode = new QRCode('qrcode', {
            render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
            width: 260,
            height: 260,
            text: url, // 二维码地址
            colorDark : "#000", //二维码颜色
            colorLight : "#fff", //二维码背景色
          });
        });
        this.getOrderstate(); //生成二维码的时候调用监听支付是否成功的方法
      },
      getOrderstate() {
        // 调用一个判断支付是否成功的接口，用这个接口我们监听支付宝/微信是否支付成功
        let that = this;
        that.timer = setInterval(()=> { //创建一个全局的定时器
          let orderId = that.$route.query.orderId;
          let params = {
            orderId: orderId
          };
          let strParams = Qs.stringify(params);
          that.$Api.getQrcodePay(strParams).then(res => {
            if (res.code != 500 && res.code != '500') {
             if(res.msg == "1"){
               clearInterval(that.timer); //别忘记关闭定时器，否则会一直调这个接口
               that.$router.push({
                 name: 'success', //支付成功以后的跳转路径
                 query: { orderId: orderId }
               });
             }
            } else {
              clearInterval(that.timer); //别忘记关闭定时器，否则会一直调这个接口
              that.$toast("服务器异常");
            }
          }).catch(err => {
            clearInterval(that.timer); //别忘记关闭定时器，否则会一直调这个接口
            that.$toast("服务器错误，请稍后重试！");
          });
        },3000);
      },
      getPayInfo() {
        let orderId = this.$route.query.orderId;
        let params = {
          orderId: orderId
        };
        let strParams = Qs.stringify(params);
        /*this.alipayUrl = 'https://www.baidu.com/';
        this.wxUrl = 'https://www.360.com/';
        this.qrcode(this.alipayUrl);*/
        this.$Api.getPayDetail(strParams).then(res => {
          /*console.log(res);*/
          if (res.code == 500 || res.code == '500') {
            this.$toast.fail('获取订单失败，请稍后重试');
          } else {
            let orderAndUserVO = res.orderAndUserVO;
            this.orderId = orderAndUserVO.orderId;
            this.html = orderAndUserVO.aliUrl;
            this.cityName = orderAndUserVO.cityName;
            this.insContValue = orderAndUserVO.typeName;
            this.contactTel = orderAndUserVO.phone;
            this.socialList = res.orderAndUserVO.orderUserListVOList;
            this.charge = orderAndUserVO.collectionFee;
            this.serviceCharge = orderAndUserVO.serviceFee;
            this.totalPrice = orderAndUserVO.totalFee;

            this.alipayUrl = orderAndUserVO.aliCode;
            this.wxUrl = orderAndUserVO.wxCode;
            this.wexinUrl = orderAndUserVO.wxUrl;
            this.qrcode(this.alipayUrl);
          }
        }).catch(err => {
          this.$toast("服务器错误，请稍后重试！");
        });
      },
      toAlipay() {
        //点击打开支付宝付款
        /*console.log('orderId:', this.$route.query.orderId);*/
        let params = {
          orderId: this.$route.query.orderId,
          /* 支付后支付宝return的url */
          // returnUrl: 'www.baidu.com''window.location.origin + window.location.pathname + '?orderId=' + this.$route.query.orderId'
          returnUrl: window.location.origin + window.location.pathname + '#/success' + '?orderId=' + this.$route.query.orderId
        };
        let strParams = Qs.stringify(params);
        this.$Api.getPayDetail(strParams).then(res => {
          /*console.log(res);*/
          if (res.code == 500 || res.code == '500') {
            this.$toast.fail('获取订单失败，请稍后重试');
          } else {
            let orderAndUserVO = res.orderAndUserVO;
            const div = document.createElement('div');
            /* 此处form就是后台返回接收到的数据 */
            div.innerHTML = orderAndUserVO.aliUrl;
            document.body.appendChild(div);
            this.$nextTick(() => {
              document.forms[0].submit();   //渲染支付宝支付页面
            });
          }
        }).catch(err => {
          this.$toast("服务器错误，请稍后重试！");
        });
      },
      toWeiXin() {
        //点击打开微信付款
        /*console.log("微信支付链接：",this.wexinUrl);*/
        let curPage = window.location.href;
        let portCal = window.location.protocol+'//';
        let portCalLen = portCal.length;
        let curPageArr = curPage.substring(portCalLen,curPage.length);
        /*console.log("协议头",curPageArr);*/
        let returnUrl = '&redirect_url='+curPageArr;
        /*console.log("当前页：", returnUrl);*/
        window.location.href = this.wexinUrl+returnUrl;
        this.getOrderstate(); //轮询
      }
    },
    mounted() {
      this.getPayInfo();
    },
    beforeDestroy() {
      // 还有一步是最容易被忽略的 跳转页面的时候也应该关闭定时器(清除轮询)
      /*console.log("定时器：", this.timer);*/
      clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "./index.css";
</style>



// WEBPACK FOOTER //
// src/layout/pay/index.vue